(function() {
    'use strict';

    angular.module('user')
        .controller('DiscountGroupUpdateController', DiscountGroupUpdateController);

    DiscountGroupUpdateController.$inject = ['$state', 'discountGroupDataSrvc', 'notificationSrvc', 'discountGroupMessagesConst', 'errorNotificationSrvc'];

    function DiscountGroupUpdateController($state, discountGroupDataSrvc, notificationSrvc, discountGroupMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_de: [],
            name_en: [],
            name_cpde: [],
            name_cpen: [],
            net_turnover: [],
            orders_count: [],
            days_count: [],
            value: [],
            nonFieldErrors: []
        };
        self.discountGroupData = {};

        self.updateDiscountGroup = updateDiscountGroup;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getDiscountGroup();
        }

        function getDiscountGroup() {
            discountGroupDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function (response) {
                    self.discountGroupData = response;
                }
            )
        }

        function updateDiscountGroup() {
            discountGroupDataSrvc.update({
                pk: self.discountGroupData.pk
            }, self.discountGroupData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", discountGroupMessagesConst.update);
                    $state.go('layout.discountGroup.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
